<template>
    <div class="firm-document-upload">
        <csp-base-file-upload
            file-input-name="fileUpload"
            :show-help-text="false"
            :upload-error-message="$t('record document upload error')"
            :upload-url="uploadUrl"
            @before-upload="handleBeforeUpload"
            @upload-complete="handleUploadComplete"
            @upload-error="$emit('upload-error')"/>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import BaseFileUpload from '@components/file/BaseFileUpload';
    import '@desktop/scss/components/firm-document-upload.scss';

    const container = Container.getInstance();
    const flashMessenger = container.getFlashMessenger();

    export default {
        components: {
            'csp-base-file-upload': BaseFileUpload,
        },
        props: {
            // If of context with type defined below
            contextId: {
                type: Number,
                required: true,
            },
            // Type must be one of [firm|firmGroup|firmAssociation|reseller]
            contextType: {
                type: String,
                required: true,
            },
            documentTypeId: {
                type: Number,
                required: true,
            },
        },
        emits: ['upload-error', 'upload-start', 'upload-success'],
        data() {
            return {
                uploadUrl: '/api/documents/' + this.documentTypeId + '/' + this.contextType + '/' + this.contextId,
            }
        },
        methods: {
            handleBeforeUpload(file, xhr, formData) {
                formData.append('name', file.name);
                this.$emit('upload-start');
            },
            handleUploadComplete() {
                flashMessenger.addSuccess(this.$t('record document upload success'));
                this.$emit('upload-success');
            },
        },
    }
</script>
